import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { BackendService, NotificationService, ModalService } from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pregled-specifikacija',
  templateUrl: './pregled-specifikacija.component.html',
})
export class PregledSpecifikacijaComponent extends SifarnikBase {
  public url: SafeResourceUrl;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    protected _modalService: ModalService,
    private _sanitizer: DomSanitizer
  ) {
    super(_backendService, _modalService, _notificationService);

    this.url = this.getSantizedURL();

    window.addEventListener('message', event => {
        if(event.data == 'top') {
          window.scrollTo(0, 0);
        }
        else if(event.data == 'bottom') {
          window.scrollTo(0, document.body.scrollHeight);
        };
      }
    )}

  getSantizedURL() {
    const token = sessionStorage.getItem('token');

    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.pregledSpecifikacijaUrl}?token=${token}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-specifikacija/pregled-specifikacija.component.ts